import { useAppStorage } from '@solfacil/plasma-utils';

import type { User } from '~/types/ecommerce/generated.codegen';

export function useUser () {
  const set = (user: User) => {
    useAppStorage().set('user', user);
  };

  const get = (): User | undefined => {
    return useAppStorage<User>().get('user');
  };

  return {
    get,
    set
  };
}
